import { useRef } from 'react';
import { PageCardRefType, PromptConfirmItemType } from '../types';

function randomPercent(): number {
  return Math.floor(Math.random() * 11) + 60;
}

/**
 * TODO: 其他系统在使用 
 * @returns
 */
export default function useGeySummary({
  isPreviews = false,
}: {
  isPreviews?: boolean;
}) {
  const summaryRef = useRef<PageCardRefType>();
  const htmlSummaryRef = useRef<HTMLDivElement>();
  const isFirst = useRef(true);

  function getSummary(promptInfo: PromptConfirmItemType) {
    if (summaryRef.current) {
      summaryRef.current.getPageSummary(
        promptInfo,
        isPreviews ? randomPercent() : 0,
      );
      isFirst.current = false;
    }
  }

  function handleStopSummary() {
    if (summaryRef.current) {
      summaryRef.current.handleStop();
    }
  }

  function toggleSummaryPrompt() {
    if (summaryRef.current) {
      summaryRef.current.toggleVisible();
    }
  }

  function showChildren() {
    if (summaryRef.current) {
      summaryRef.current?.showChildren?.();
    }
  }

  function showFullClick() {
    if (summaryRef.current) {
      summaryRef.current?.openFullDialog?.();
    }
  }

  return {
    htmlSummaryRef,
    summaryRef,
    getSummary,
    toggleSummaryPrompt,
    handleStopSummary,
    showChildren,
    showFullClick,
    isFirst: isFirst.current,
  };
}

export function useGetSummaryList<T extends string>({
  isPreviews = false,
  keys = [],
}: {
  isPreviews?: boolean;
  keys: readonly T[];
}) {
  // Initialize ref with proper typing
  const summaryRef = useRef<Record<T, PageCardRefType | null>>(
    keys.reduce((acc, key) => ({ ...acc, [key]: null }), {} as Record<T, null>),
  );

  const isFirst = useRef<Record<T, boolean | null>>(
    keys.reduce((acc, key) => ({ ...acc, [key]: true }), {} as Record<T, null>),
  );

  function initRef(value: PageCardRefType, key: T): void {
    summaryRef.current[key] = value;
  }

  function getSummary(promptInfo: PromptConfirmItemType, key: T) {
    const summaryRefValue = summaryRef.current[key];

    if (summaryRefValue) {
      summaryRefValue.getPageSummary(
        promptInfo,
        isPreviews ? randomPercent() : 0,
      );
      isFirst.current[key] = false;
    }
  }

  function handleStopSummary(key: T) {
    const summaryRefValue = summaryRef.current[key];
    if (summaryRefValue) {
      summaryRefValue.handleStop();
    }
  }

  function toggleSummaryPrompt(key: T) {
    const summaryRefValue = summaryRef.current[key];
    if (summaryRefValue) {
      summaryRefValue.toggleVisible();
    }
  }

  return {
    initRef,
    getSummary,
    isFirst: isFirst.current,
    handleStopSummary,
    toggleSummaryPrompt,
  };
}
